<template>
  <div class="flex flex-col h-full">
    <div class="w-full float-left flex-shrink-0">
      <TabsSelector @update="selectedComponent = $event" ref="tabSelector" />
    </div>
    <div class="w-full float-left flex-grow overflow-hidden">
      <keep-alive>
        <component
          :is="selectedComponent"
          ref="selected"
        
        />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import TabsSelector from "./TabsSelector.vue";
import InstantOrders from "@/components/InstantOrders.vue";
import ReservationOrders from "@/components/ReservationOrders.vue";
import socketEventsMixin from "@/mixins/formatDateMixin";

export default {
  name: "Tabs",
  mixins: [socketEventsMixin],
  components: {
    TabsSelector,
    "instant-orders": InstantOrders,
    "reservation-orders": ReservationOrders,
  },
  data() {
    return {
      selectedComponent: "",
      instantOrdersData: null,
      reservationOrdersData: null,
    };
  },
  methods: {
    decreaseCount(data) {
      console.log(data);
    },
    addOrder(data, cnt = 1) {

      if (this.selectedComponent === "instant-orders") {
        console.log("INSTANT ORDER");

        if (data.now == 1) {
          console.log("MUST BE ADDED");
          this.$refs.selected.addToOrders(data);
          return;
        }
      } else if (this.selectedComponent === "reservation-orders")

      if (!data.now) {
        this.$refs.selected.addToOrders(data);
          return;
        }
    },
  },
};
</script>

<style lang="scss" scoped></style>
